module.exports = __webpack_public_path__ + "static/logo-hover-fef76f1d07cd00299aec07d803d7d774.svg";